import React from "react";
import PropTypes from "prop-types";

const NoData = ({ page, noRecordsMessage }) => (
  <div>
    <hr />
    <div style={{ textAlign: "center" }}>
      {page === "open" ? (
        <p className="grey-text center-text">
          {noRecordsMessage}<br />
          To request a sub for your shift, visit your&nbsp;
          <a href="/my_schedule" className="styled-link">
            My Schedule page
          </a>, open a shift, and click "REQUEST SUB".
        </p>
      ) : page === "pending" ? (
        <p className="grey-text center-text">
          {noRecordsMessage}<br />
          Visit&nbsp;
          <a href="/sub_requests" className="styled-link">
            Open Sub Requests
          </a>
          &nbsp;to claim a shift.
        </p>
      ) : (
        <p className="grey-text center-text">
          {noRecordsMessage}<br />
          Visit&nbsp;
          <a href="/sub_requests_pending_approval" className="styled-link">
            Sub Requests Pending Approval
          </a>
          &nbsp;to approve or deny a pending sub request.
        </p>
      )}
    </div>
  </div>
);

NoData.propTypes = {
  page: PropTypes.string,
  noRecordsMessage: PropTypes.string
};

export default NoData;
